import React from 'react';

import BooleanInput from 'bundles/apex/custom_fields/form/boolean';
import DealField, { propTypes } from './field';

export function BooleanDealField({ changeDeal, deal, label, name }) {
  return (
    <BooleanInput
      label={label}
      name={name}
      value={deal[name]}
      onChange={changeDeal}
    />
  );
}

BooleanDealField.propTypes = propTypes;

export default DealField(BooleanDealField);
